import React, { useEffect } from "react";
import articlesStore from "../../../store/articles/ArticlesStore";
import { useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getArticles } from "../../../store/articles/ArticlesApi";
import { Button, IconButton, Typography } from "@material-ui/core";
import ArticleTagEditor from "../ArticleTagEditor";
import { ToastContainer } from "react-toastify";
import { Add } from "@material-ui/icons";
import { useDialog } from "../../Dialogs/DialogProvider";
import TextFieldDialog from "../../Dialogs/TextFieldDialog";

function Menugroups() {
  const merchantId = Number.parseInt(useParams().merchantId);
  const [menugroupsFromArticles, setMenugroupsFromArticles] = React.useState(null);
  const [menugroupsFromSpQrCodes] = React.useState(null); // todo
  const [menugroupsCreated, setMenugroupsCreated] = React.useState([]);
  let menugroups = null;
  if (menugroupsFromArticles != null) {
    menugroups = menugroupsFromArticles;
  }
  if (menugroupsFromSpQrCodes != null) {
    if (menugroups == null) {
      menugroups = menugroupsFromSpQrCodes;
    } else {
      menugroups = menugroups.concat(menugroupsFromSpQrCodes);
    }
  }
  menugroupsCreated.forEach((menugroupCreated) => {
    if (menugroups == null) {
      menugroups = [menugroupCreated];
    } else if (!menugroups.includes(menugroupCreated)) {
      menugroups.push(menugroupCreated);
    }
  });
  const [selectedMenugroup, setSelectedMenugroup] = React.useState(null);

  const [openDialog, closeDialog] = useDialog();

  const onMenuUpdated = () => {
    if (articlesStore.menugroups != null) {
      setMenugroupsFromArticles(Object.keys(articlesStore.menugroups).map((menugroup) => menugroup));
    } else {
      setMenugroupsFromArticles(null);
    }
  };

  useEffect(() => {
    articlesStore.on(articlesStore.events.MENU_UPDATED, onMenuUpdated);
    return () => {
      articlesStore.removeListener(articlesStore.events.MENU_UPDATED, onMenuUpdated);
    };
  }, []);

  useEffect(() => {
    if (merchantId !== articlesStore.merchantId) {
      if (menugroupsFromArticles != null) {
        setMenugroupsFromArticles(null);
      }
      getArticles(merchantId);
    } else if (menugroupsFromArticles == null && articlesStore.menugroups != null) {
      onMenuUpdated();
    }
  }, []);

  if (!menugroupsFromArticles) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <div>
      <Typography>Alle artikelen die niet gekoppeld zijn, zitten in alle menukaarten.</Typography>
      <div style={{ display: "flex", flexFlow: "wrap" }}>
        <Button
          key={null}
          style={{ margin: "8px 16px" }}
          variant={null === selectedMenugroup ? "contained" : "outlined"}
          color={"primary"}
          onClick={() => {
            setSelectedMenugroup(null);
          }}
        >
          Geen menukaart
        </Button>
        {menugroupsFromArticles.map((menugroup) => (
          <Button
            key={menugroup}
            style={{ margin: "8px 16px" }}
            variant={menugroup === selectedMenugroup ? "contained" : "outlined"}
            color={"primary"}
            onClick={() => {
              setSelectedMenugroup(menugroup);
            }}
          >
            {menugroup}
          </Button>
        ))}
        <IconButton
          onClick={() => {
            openDialog({
              children: (
                <TextFieldDialog
                  title={"Menukaart toevoegen"}
                  value={""}
                  open={true}
                  onSubmit={(value) => {
                    closeDialog();
                    value = value.toUpperCase();
                    setMenugroupsCreated(menugroupsCreated.concat([value]));
                  }}
                />
              ),
            });
          }}
        >
          <Add />
        </IconButton>
      </div>
      <ArticleTagEditor selectedTag={selectedMenugroup} type={"menu_tags"} />
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default Menugroups;
